import { render, staticRenderFns } from "./ActiveForward.vue?vue&type=template&id=de79f9cc&scoped=true"
import script from "./ActiveForward.vue?vue&type=script&lang=js"
export * from "./ActiveForward.vue?vue&type=script&lang=js"
import style0 from "./ActiveForward.vue?vue&type=style&index=0&id=de79f9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de79f9cc",
  null
  
)

export default component.exports